import { Link } from "react-router-dom";
import Logo from "./Logo";
import { WhatsAppIcon } from "./icons";
import { WHATSAPP_PHONE_DISPLAY, WHATSAPP_URL } from "@/lib/constants";

const LEGAL = [
  { to: "/aviso-legal", label: "Aviso legal", testid: "footer-link-aviso-legal" },
  { to: "/privacidad", label: "Privacidad", testid: "footer-link-privacidad" },
  { to: "/cookies", label: "Cookies", testid: "footer-link-cookies" },
];

export default function Footer() {
  return (
    <footer className="border-t border-white/10 bg-[#0d1f31]" data-testid="site-footer">
      <div className="mx-auto max-w-6xl px-4 py-14 sm:px-6">
        <div className="grid gap-10 sm:grid-cols-3">
          <div>
            <Logo variant="light" />
            <p className="mt-3 max-w-xs text-sm leading-relaxed text-white/55">
              Pisos y casas en alquiler y venta en toda España.
            </p>
          </div>
          <nav className="flex flex-col gap-2.5" aria-label="Legal">
            <p className="text-xs font-extrabold uppercase tracking-[0.18em] text-white/40">Legal</p>
            {LEGAL.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                data-testid={link.testid}
                className="text-sm font-semibold text-white/60 transition-colors duration-200 hover:text-[#14b8a6]"
              >
                {link.label}
              </Link>
            ))}
          </nav>
          <div className="flex flex-col gap-2.5">
            <p className="text-xs font-extrabold uppercase tracking-[0.18em] text-white/40">Contacto</p>
            <a
              href={WHATSAPP_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-whatsapp-link"
              className="inline-flex items-center gap-2 text-sm font-semibold text-white/60 transition-colors duration-200 hover:text-[#25D366]"
            >
              <WhatsAppIcon className="h-4 w-4" />
              {WHATSAPP_PHONE_DISPLAY}
            </a>
            <Link
              to="/panel"
              data-testid="footer-link-panel"
              className="text-sm font-semibold text-white/60 transition-colors duration-200 hover:text-[#14b8a6]"
            >
              Acceso equipo
            </Link>
          </div>
        </div>
        <div className="mt-12 border-t border-white/10 pt-6">
          <p className="text-xs text-white/45" data-testid="footer-copyright">© 2026 Nidoria</p>
        </div>
      </div>
    </footer>
  );
}
